import React from "react";
import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App.js";
import { initTelegramIfPresent } from "./shared/tg.js";
import "./styles/tokens.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("no #root");

// Tell Telegram we're ready to be shown (hides its spinner) and expand
// to the full viewport. No-op when the mini-app is opened in a regular
// browser.
initTelegramIfPresent();

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline shell + kid-view caching.
// autoUpdate strategy (see vite.config.ts) — silently swap the worker on
// next navigation without user prompt.
registerSW({ immediate: true });
